module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-3-0e2465612ab100b34aa936ac92380759.jpg";